<loading *ngIf="isLoading" size="large" expand="full-screen"></loading>
<toaster #applicationToaster (action)="navigateToErrorSection()"></toaster>
<!-- there are two containers here because the outer one is used to calculate position
     and the second is used to show the content -->
<div #topBanner class="banner-container">
  <div #topBannerContent class="banner-content">
    <div *ngIf="showAdvisorAnsweredBanner" class="top-banner-small">
      Your financial professional has entered information on your behalf. Please ensure it is correct and answer any
      remaining questions.
      <img
        class="top-banner-small__img-close"
        src="/common/img/close-button-white.svg"
        (click)="removeAdvisorAnsweredBanner()"
      />
    </div>
    <div *ngIf="showNewFilingNotice" class="top-banner-small">
      We're sorry, our application recently changed. Please fill out our improved application to get the most accurate
      policy offer.
    </div>
    <div *ngIf="showLifeBridgeBanner()" class="top-banner-small">
      <div *ngIf="currentSection === 1">
        <!-- owner page:1 -->
        <p>
          This page is prefilled, as the owner of all LifeBridge policies is the MassMutual Trust Company. Should a
          claim be paid, the MassMutual Trust Company will make payments on behalf of the insured's beneficiaries for
          educational expenses. Proceed to the bottom of this page and click Next.
        </p>
      </div>
      <div *ngIf="currentSection === 3">
        <!-- purpose of insurance page:3 -->
        <p>
          This page is prefilled, as the owner of all LB policies is the MassMutual Trust Company. Should a claim be
          paid, the MassMutual Trust Company will make payments on behalf of the insured's beneficiaries for educational
          expenses. Proceed to the bottom of this page and click Next.
        </p>
      </div>
      <div *ngIf="currentSection === 4">
        <!-- existing -->
        <p>
          This section is not required to be completed. Under the LifeBridge Program, the $50,000 death benefit is paid
          to what is called a trust. Simply put, the Trust holds the dollars that will pay for the educational expenses
          of your children. The trust will pay benefits directly to the school(s) your eligible child(ren) attend.
        </p>
        <p>
          Under the terms of the trust, no children will receive benefits unless they are eligible under the terms of
          the LifeBridge Program and they are designated on an initial or amended LifeBridge Enrollment Form. This form
          will be completed during the process of signing your application documents.
        </p>
      </div>
      <div *ngIf="currentSection === 6">
        <!-- policy information page:6 -->
        <p>
          This page is prefilled, as the owner of all LB policies is the MassMutual Trust Company. Should a claim be
          paid, the MassMutual Trust Company will make payments on behalf of the insured's beneficiaries for educational
          expenses. Proceed to the bottom of this page and click Next.
        </p>
      </div>
      <div *ngIf="currentSection === 7">
        <!-- acknowledge page:7 -->
        <p>
          This page is prefilled, as the owner of all LB policies is the MassMutual Trust Company. The only item that
          you need to complete on this page is checking your acknowledgment box at the bottom of the page.
        </p>
      </div>
      <div *ngIf="currentSection === 8">
        <!-- existing -->
        <p>
          This section is not required to be completed. Under the LifeBridge Program, Massachusetts Mutual Life
          Insurance Company (MassMutual) will issue a $50,000 term life insurance policy to a trust for a period of 10
          years at no cost to you.
        </p>
      </div>
    </div>
  </div>
</div>
<div *ngIf="showReadOnlyBanner" class="top-banner-small">
  You are viewing the application but cannot make changes. <b>Only the customer can make edits to the application. </b>
</div>

<div *ngIf="!isCurrentSectionCIR">
  <policy-details *ngIf="!isNewYorkApplication"></policy-details>
  <policy-details-ny *ngIf="isNewYorkApplication"></policy-details-ny>
</div>
<policy-details-cir *ngIf="isCurrentSectionCIR"></policy-details-cir>
<div *ngIf="showAdvisorEditBanner" class="top-banner-small">
  Your client cannot access the application until you finish editing and resend it to them.
  <img
    class="top-banner-small__img-close"
    src="/common/img/close-button-white.svg"
    (click)="removeAdvisorEditBanner()"
  />
</div>
<div class="application-form" [class.ca-application]="isCAApplication">
  <div class="application-client-banner"></div>
  <div class="telecmi-app-alert-container">
    <cpds-alert
      *ngIf="isTeleCMICompleted && isTeleCMI && isTeleInterviewerLoggedIn && teleCMIStatus"
      [intent]="alertIntent.INFO"
      class="telecmi-app-alert"
    >
      <span *ngIf="teleCMIStatus === teleCaseStatus.COMPLETED"
        >This CMI is completed and was sent to the client to review.
        <a class="telecmi-app-alert-link" (click)="showEditTeleCmiModal()">Edit responses</a>
      </span>
      <span *ngIf="teleCMIStatus === teleCaseStatus.CLOSED"
        >This application has been submitted. The CMI is no longer editable.
      </span>
    </cpds-alert>
  </div>
  <div *ngIf="isMetadataLoaded" class="application-form-container">
    <div class="application-form-container__main">
      <application-form-section
        class="application-section-container__item"
        [appSection]="section"
        *ngFor="let section of appState.appMetadata.children"
      ></application-form-section>
      <div *ngIf="is2020CoverpathOrMMD" class="application-form-footer">{{ getFilingNumber() }}</div>
      <navigation
        *ngIf="!isCAApplication"
        class="application-section-navigation"
        (validationErrorExists)="showSectionValidationToast()"
      ></navigation>
      <navigation-ca
        *ngIf="isCAApplication"
        class="application-section-navigation"
        (validationErrorExists)="showSectionValidationToast()"
      ></navigation-ca>
    </div>
    <div class="application-form-container__menu">
      <div *ngIf="showAMCemailVerify" class="autofill-coin autofill-coin__stack1" (click)="_testAMCSetEmailVerified()">
        <img
          class="autofill-coin__image"
          alt="AMC verify email coin"
          title="Set AMC email to verified"
          src="/common/img/verify-email.png"
        />
      </div>
      <div
        *ngIf="showAMCemailVerify"
        class="autofill-coin autofill-coin__stack"
        (click)="_testAMCemailVerifyCoverpath()"
      >
        <img
          class="autofill-coin__image"
          alt="AMC coin"
          title="AMC whitelist email and resend email verify"
          src="/common/img/whitelist-email.jpg"
        />
      </div>
      <div *ngIf="showAutoFill" class="autofill-coin" (click)="_testAutofillCoverpath()">
        <img class="autofill-coin__image" src="/common/img/doge-coin.jpeg" />
      </div>
      <div class="section-menu-container">
        <section-menu-ca
          *ngIf="isCAApplication"
          (goToError)="navigateToErrorSection()"
          (showNavToast)="showSectionValidationToast()"
          (goToCaseSetup)="navigateToSection('Case Setup')"
        ></section-menu-ca>
        <section-menu
          *ngIf="!isCAApplication"
          (goToError)="navigateToErrorSection()"
          (showNavToast)="showSectionValidationToast()"
          (goToCaseSetup)="navigateToSection('Case Setup')"
        ></section-menu>
      </div>
    </div>
  </div>
</div>
<ng-template #editTeleCmiModalTpl
  >If you continue, the client will lose their ability to review their application until you’ve submitted your
  changes.</ng-template
>
